// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';
//Models
import { AttendancesList, AttendancesFilter, CheckAttendances, Manager } from '../models'

@Injectable()
export class AttendanceService {
    // Api Domain Url
    private apiUrl = '';
    // Url List for attendances Site 
    private attendancesListUrl = '/hol-attendances';
    private checkAttendancesUrl = '/hol-check-attendance'
    
    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }


    /** 
     * Get all attendances list 
     * @returns {AttendancesList[]} : list of the attendances.
     */
    getAttendancesList(filter: AttendancesFilter): Observable<AttendancesList> {
        let requestUrl = this.apiUrl + this.attendancesListUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]) {
                if(hasFilter) {
                    requestUrl += '&';
                }
                else{
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<AttendancesList>(requestUrl);
    }

    checkAttendances(checkAttendances: CheckAttendances): Observable<any> {
        const requestUrl = this.apiUrl + this.checkAttendancesUrl;
        // Post command
        const body = JSON.stringify(checkAttendances)

        return this.apiService.patch(requestUrl, body); 
    }
}


// WEBPACK FOOTER //
// ./src/holiday/services/AttendanceService.ts